import { useEffect, useContext, useState } from 'react';
import
{
  NewCardsContainer,
  TwitterCardsContainer,
} from './Home.styles';
import MainWrapper from '../../components/Wrappers/MainWrapper/MainWrapper';
import NewsCards from '../../components/HomePage/NewsCards/NewsCards';
import TwitterCards from '../../components/HomePage/TwitterCards/TwitterCards';

// Contexts
import { BaseContext } from '../../providers/Global/BaseProvider';
import { HomeContext } from '../../providers/Home/HomeProvider';

import { getBoardsRezzilIndex } from '../../api';
import { routes } from '../../options/routes';
import { checkForFailedInvoices } from '../../utils/helpers/billingHelper';
import Index1Link from '../../components/Links/Index1Link/Index1Link';



const Home = () =>
{
  const baseContext = useContext(BaseContext);
  const homeContext = useContext(HomeContext);
  const [loading, setLoading] = useState(true);
  const [newsData, setNewsData] = useState([]);
  const [twitterData, setTwitterData] = useState([]);
  const [error, setError] = useState({
    show: false,
    message: '',
  });

  useEffect(() =>
  {
    if (!baseContext.baseData.loading && !baseContext.baseData.hasEliteLicence)
    {
      window.location.href = `${routes.indexLicences}`;
    }

    if (!baseContext.baseData.loading && homeContext.homeData.allLoaded)
    {
      if (!baseContext.baseData.hasEliteLicence)
      {
        window.location.href = `${routes.indexLicences}`;
      }

      const { id } = baseContext.baseData.clubProfile;
      setLoading(false);
      if (homeContext.homeData.apiError)
      {
        setError({
          show: true,
          message: 'Unable to load some or all page content. Please refresh and try again.'
        });
      }

      // Set news and Twitter data
      const { news, twitter } = homeContext.homeData;
      setNewsData(news);
      setTwitterData(twitter);
      // Prefetch rezzil index leaderboard for caching on this page. This does not block any other loading.
      getBoardsRezzilIndex(id);
    }
    checkForFailedInvoices(baseContext, setError);

  }, [baseContext, homeContext]);

  const handleBannerClose = () =>
  {
    setError({
      show: false,
      message: '',
    });
  };

  return (
    <>
      {
        <MainWrapper
          error={error.show}
          errorData={error}
          apiMessage={error.message}
          handleBannerClose={handleBannerClose}
          activeRoute={routes.home}
          clubLogo={baseContext.baseData.clubProfile.logo}
          dataLoading={false}
          hasEliteLicence={baseContext.baseData.hasEliteLicence}
          hasRezzilPlayerLicence={baseContext.baseData.hasRezzilPlayerLicence}
          licences={baseContext.baseData.licences}
        >
          <NewCardsContainer>
            <NewsCards
              articles={newsData}
            />
          </NewCardsContainer>
          {/* <TwitterCardsContainer>
            <TwitterCards
              posts={twitterData}
            />
          </TwitterCardsContainer> */}
          <Index1Link />
        </MainWrapper>
      }
    </>
  )
};

export default Home;
